export const DEFAULT_BORDER_OFFSET = '-1px'
